import type { BlogPost } from '@types'

// A post with no date renders "Date unavailable", never today's date: matches [post]/page.tsx. [S20-1320]
export function formatPostDate(timestamp?: number): string {
  return timestamp
    ? new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric' }).format(new Date(timestamp))
    : 'Date unavailable'
}

// The WordPress slug, which the editors choose, not the title cut to 64 characters plus the id. [S20-1385]
export function postUrl(post: Pick<BlogPost, 'slug'>): string {
  return `/blogs/${post.slug}`
}
